import React from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";

const TierLabel = () => {
  const { t } = useTranslation();
  return (
    <div className="tier_label_container position-absolute">
      <i className="star_icon" />
      <span className="black_tier_label">{t("blackTier")}</span>
    </div>
  );
};

export default TierLabel;
